function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconB2BProcessing = function SvgIconB2BProcessing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 1.903,
    cy: 1.903,
    r: 1.903,
    transform: "translate(6.266 14.097)",
    style: {
      fill: "#198cff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.224 179.329a16 16 0 1 1 16-16 16.018 16.018 0 0 1-16 16Zm0-29.693a13.693 13.693 0 1 0 13.694 13.693 13.709 13.709 0 0 0-13.694-13.694Z",
    transform: "translate(-170.224 -147.329)",
    style: {
      fill: "#198cff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.903,
    cy: 1.903,
    r: 1.903,
    style: {
      fill: "#198cff"
    },
    transform: "translate(14.097 14.097)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.903,
    cy: 1.903,
    r: 1.903,
    style: {
      fill: "#198cff"
    },
    transform: "translate(21.927 14.097)"
  }));
};
export default SvgIconB2BProcessing;